import { GridApi } from "ag-grid-community";
import {
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from "ag-grid-enterprise";
import debounce from "lodash.debounce";
export abstract class AgGridCursorDataSource<
  Data extends { id: string },
> implements IServerSideDatasource<Data> {
  protected endCursor: string | undefined = undefined;
  protected hasNextPage: boolean = true;
  protected data: Data[] = [];
  protected api: GridApi | undefined = undefined;

  public getRows(params: IServerSideGetRowsParams<Data>) {
    void this.getAsyncRows(params);
  }

  public clear() {
    this.endCursor = undefined;
    this.hasNextPage = true;
    this.data = [];
    this.api = undefined;
  }

  public async loadAll() {
    while (this.api && this.hasNextPage) {
      await this.fetchData();
      this.onDataUpdate();
    }
  }

  protected async getAsyncRows(params: IServerSideGetRowsParams<Data>) {
    const { request } = params;
    this.setApi(params.api);

    const startRow = request.startRow ?? 0;
    const endRow = request.endRow ?? 0;
    while (this.data.length < endRow && this.hasNextPage) {
      await this.fetchData();
      requestAnimationFrame(() => {
        this.onDataUpdate();
      });
    }

    const rowData = this.data.slice(startRow, endRow);
    params.success({ rowData });
  }

  protected debouncedReload: ReturnType<typeof debounce> = debounce(
    this.reload,
    500,
    {
      trailing: true,
    }
  );

  protected reload() {
    this.endCursor = undefined;
    this.hasNextPage = true;
    this.data = [];
    requestAnimationFrame(() => {
      this.api?.refreshServerSide({ purge: true });
      this.onDataUpdate();
    });
  }

  protected abstract fetchData(): Promise<void>;

  protected onDataUpdate() {}

  protected setApi(api: GridApi) {
    if (this.api === undefined) {
      this.api = api;
    }
  }
}
